'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconDonutChart, iconDonutChartTag } from '@ni/nimble-components/dist/esm/icons/donut-chart';
import { wrap } from '../../utilities/react-wrapper';

export type { IconDonutChart };
export { iconDonutChartTag };
export const NimbleIconDonutChart = wrap(IconDonutChart);